import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/moderation-dash/moderation-dash-module');

export default function ModerationDashboardRootLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/moderationdash/one/${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'moderationdash',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceDashboard />
        </DatastoreProvider>
    );
}
